<template>
  <div class="home">
    <Navbar></Navbar>
    <MiniCart></MiniCart>
    <div style="margin-top: 20px; padding: 0 20px">
      <h1>
        <strong>CONDICIONES GENERALES DE CONTRATACIÓN</strong>
      </h1>

      <br />

      <p>
        <strong>1. Objeto</strong>
      </p>

      <p>
        Los presentes términos regulan la adquisición de los productos
        comercializados en la carta de
        <strong>{{ companyNameLegal }}</strong> (en adelante
        <strong>{{ companyShortName }}</strong
        >) a través de la presente nuestra web app (en adelante,
        <strong>aiwannapay</strong>) para ser consumidos dentro del
        establecimiento.
      </p>

      <p>
        <strong>2. Información legal del responsable</strong>
      </p>

      <p>Todos los productos son comercializados por:</p>
      <ol>
        <li style="display: flex;">
          <span style="margin-right: 10px;">Denominación social:</span>
          <strong>{{ companyNameLegal }}</strong>
        </li>
        <li style="display: flex;">
          <span style="margin-right: 10px;">CIF:</span
          ><strong>{{ companyNif }}</strong>
        </li>
        <li style="display: flex;">
          <span style="margin-right: 10px;">Domicilio:</span>
          <strong>{{ companyAddress }}</strong>
        </li>
        <li style="display: flex;">
          <span style="margin-right: 10px;">Datos registrales:</span>
          <strong>{{ companyRegisterData }}</strong>
        </li>
        <li style="display: flex;">
          <span style="margin-right: 10px;">Datos de contacto:</span>
          <strong>{{ companyEmail }}</strong>
        </li>
      </ol>

      <p></p>

      <p>
        <strong>3. Elegibilidad</strong>
      </p>

      <p>
        Los presentes términos de uso son aplicables a aquellas personas físicas
        mayores de 18 años (en adelante, el/los “Usuario/s”).
      </p>

      <p>
        La mera utilización de <strong>aiwannapay</strong> por el Usuario
        comporta la plena aceptación de estos términos de uso. Si un Usuario no
        pudiera aceptar alguno de estos términos de uso por algún motivo deberá
        abstenerse de utilizar <strong>aiwannapay</strong> y deberá ponerse en
        contacto con <strong>{{ companyShortName }},</strong> para ordenar el
        pedido de forma tradicional.
      </p>

      <p>
        <strong>4. Condiciones de uso</strong>
      </p>

      <p>
        La utilización de <strong>aiwannapay</strong> requiere de conexión a
        Internet. La disponibilidad y la calidad del acceso a Internet pueden
        variar en función de diversos factores como el ancho de banda
        disponible, la red de datos utilizada, el tipo de dispositivo utilizado
        entre otros. Dichos factores no dependen de
        <strong>{{ companyShortName }}</strong> ni ésta se responsabiliza de
        ningún aspecto relacionado con el servicio de acceso a Internet del
        Usuario.
      </p>

      <p>
        La web app está disponible para smartphones con sistemas operativos
        Android OS y Apple IOS. Requiere que el dispositivo tenga la capacidad
        de leer códigos QR.
      </p>

      <p>
        La utilización de <strong>aiwannapay</strong> salvo que se indique lo
        contrario es gratuita.
      </p>

      <p>
        El acceso a los servicios prestados a través de
        <strong>aiwannapay</strong> no requiere, con carácter general, la previa
        suscripción o registro de los Usuarios, sin perjuicio, de que para
        acceder a determinados servicios sí se exija cumplimentar previamente el
        correspondiente registro.
      </p>

      <p>
        El Usuario se compromete a utilizar los Contenidos y servicios
        disponibles en <strong>aiwannapay</strong> de conformidad con los
        presentes términos de uso, así como de conformidad con la legislación
        aplicable, la moral y las buenas costumbres, quedando prohibido realizar
        pedidos o comandas a mala fe, suplantar la identidad de terceros, o
        utilizar <strong>aiwannapay</strong> para atentar contra los derechos de
        <strong>{{ companyShortName }}</strong> o de terceros.
      </p>

      <p>
        El Usuario se abstendrá de utilizar <strong>aiwannapay</strong> para
        cualquier tipo de actuación comercial o empresarial, a menos que
        <strong>{{ companyShortName }}</strong> haya autorizado dicho uso
        previamente y por escrito.
      </p>

      <p>
        <strong>5. Condiciones de servicio</strong>
      </p>

      <p>
        La realización de un pedido implicará la aceptación de las presentes
        Condiciones del Servicio
      </p>

      <p>
        <strong>{{ companyShortName }}</strong> podrá retirar o suspender en
        cualquier momento y sin necesidad de previo aviso la prestación de los
        servicios a aquellos Usuarios que incumplan lo establecido en los
        presentes términos de uso, como por ejemplo aquellos usuarios que no
        tengan la mayoría de edad.
      </p>

      <p>
        Los productos objeto de este servicio serán aquellos expresamente
        expuestos en <strong>aiwannapay</strong> donde los Usuarios podrán
        obtener información adicional sobre las características o disponibilidad
        para cualquier duda por favor consulte con el personal de sala.
      </p>

      <p>
        La oferta de algunos de los productos expuestos en
        <strong>aiwannapay</strong> puede estar sujeta a limitaciones o
        restricciones en la venta, en función del horario de venta, o edad del
        Usuario. Las fotografías e imágenes de los productos presentados en
        <strong>aiwannapay</strong> son meramente orientativas y el aspecto
        visual real de algunos productos puede variar respecto a estas imágenes.
      </p>

      <p>
        Si por algún motivo derivado del desabastecimiento de productos o
        incidencias en el Servicio algún producto no pudiera ser suministrado,
        esta situación quedará indicada en a través de
        <strong>aiwannapay</strong> o se contactará al Usuario para informarle
        de la misma en caso de ser necesario, dándole la alternativa de escoger
        otro producto similar o, en su caso, la devolución de los importes
        abonados.
      </p>

      <p>
        <strong>{{ companyShortName }}</strong> se reserva el derecho a
        modificar sin previo aviso el listado de productos. No obstante, éste se
        compromete a no modificar las características de los productos, que
        conformen los pedidos, que ya hayan sido solicitados por los Usuarios.
      </p>

      <p>
        <strong>6. Proceso de compra</strong>
      </p>

      <p>
        El Usuario, escaneará con su dispositivo el código QR asociado a la mesa
        que ocupe, para a continuación poder ir seleccionando los artículos que
        desee y éstos se irán añadiendo en la cesta.
      </p>

      <p>
        Una vez confirmada la compra, el Usuario, tendrá que rellenar los campos
        requeridos: información personal necesaria para realizar el pedido,
        datos de facturación. Una vez que el Usuario haya leído y comprendido
        estas Condiciones del Servicio, éste podrá hacer clic en el botón
        correspondiente para aceptarlas y proceder, en su caso, con la forma de
        pago.
      </p>

      <p>
        <strong>7. Precios</strong>
      </p>

      <p>
        El precio de cada producto, será el que se estipule en cada momento en
        nuestra plataforma
        <strong>aiwannapay</strong>, salvo en caso de error manifiesto. No
        estaremos obligados a suministrarle ningún producto al precio inferior
        incorrecto, si el error en el precio es obvio e inequívoco y hubiera
        podido ser reconocido de forma razonable por usted como precio
        incorrecto. Los precios de los artículos aplicados están representados
        en EUROS (EUR) e incluyen el IVA (Impuesto sobre el Valor Añadido)
      </p>

      <p>
        Los precios pueden cambiar en cualquier momento, pero (salvo en lo
        establecido anteriormente) los posibles cambios no afectarán a los
        pedidos con respecto a los que ya le hayamos enviado una Confirmación de
        Pedido.
      </p>

      <p>
        Los precios están denominados en EUROS. Los pagos y reembolsos se
        realizarán en euros (EUR). Si su tarjeta de crédito/débito no está
        denominada en EUROS, el tipo de cambio lo aplicará la entidad bancaria
        correspondiente según el tipo de cambio de mercado y podrá variar con
        respecto al precio indicado en nuestra plataforma
        <strong>aiwannapay</strong>.
      </p>

      <p>
        <strong>8. Método de pago</strong>
      </p>

      <p>
        Previamente a la confirmación final, se mostrará un resumen del pedido
        online y todos los datos introducidos podrán ser corregidos por el
        Usuario. La confirmación final del pedido implica la celebración del
        contrato con lFfh°. El Usuario deberá realizar el pago para poder
        iniciar la preparación del pedido o comanda.
      </p>

      <p>
        <strong>{{ companyShortName }}</strong> podrá rechazar un pedido del
        Usuario en caso de que no se realice correctamente el pago por éste. En
        caso de pago con tarjeta, si ésta resultara denegada, se informará al
        Usuario, y se le pedirá que pague de otra forma. Si no fuera posible, se
        procederá a anular el pedido comunicándolo al Usuario.
      </p>

      <p>
        El Usuario podrá efectuar el pago de su pedido a través de los
        siguientes medios en la medida en que estén disponibles para el
        Servicio:
      </p>

      <p>
        (i) Tarjeta de crédito: Los datos bancarios recogidos mediante la
        pasarela de pago son cifrados y transmitidos de forma segura a los
        servidores del banco. <strong>{{ companyShortName }}</strong> se reserva
        el derecho a iniciar las acciones legales que considere oportunas contra
        todo aquel que realice una transacción fraudulenta o introduzca datos de
        tarjetas de crédito sin tener la autorización del titular de las mismas.
      </p>

      <p>
        (ii) Pago en efectivo: El Usuario abona el importe en el momento de la
        realización del pedido. El Usuario podrá especificar, durante la
        realización del pedido, el cambio que necesita.
      </p>

      <p>
        En el caso de pago por tarjeta de crédito, el pedido no se considerará
        efectivo hasta que el
        <strong>{{ companyShortName }}</strong> obtenga confirmación bancaria
        del pago.
      </p>

      <p>
        Con independencia de la modalidad de pago elegida, una vez efectuada
        <strong>{{ companyShortName }}</strong> realizará la confirmación del
        pedido a través de <strong>aiwannapay</strong>.
      </p>

      <p>
        <strong>9. Pedidos</strong>
      </p>

      <p>
        Una vez comprobado y validado el pago,
        <strong>{{ companyShortName }}</strong> procederá a la preparación del
        pedido o comanda y a servirlo en la mesa del usuario en el menor tiempo
        posible. Los datos necesarios de facturación serán proporcionados a
        <strong>{{ companyShortName }},</strong> conforme a la Política de
        Privacidad.
      </p>

      <p>
        El plazo para servir el pedido o comanda, que en todo caso será
        orientativo, dependerá de la cantidad de comandas acumuladas en cocina
        y/o barra. <strong>{{ companyShortName }}</strong> procurará despachar
        el pedido en el menor tiempo posible.
      </p>

      <p>
        El Usuario deberá comprobar los productos servidos en presencia del
        personal de sala para comprobar la integridad y estado de éstos con el
        propósito de dar su conformidad.
      </p>

      <p>
        <strong>10. Derecho de desistimiento</strong>
      </p>

      <p>
        No existirá derecho de desistimiento debido a la naturaleza perecedera
        de los productos suministrados de conformidad con la legislación
        aplicable.
      </p>

      <p>
        <strong>11. Restricciones legales</strong>
      </p>

      <p>
        De conformidad con lo dispuesto en la normativa aplicable en materia de
        drogodependencia y prevención del consumo de bebidas alcohólicas en
        menores de edad, está prohibida la venta, suministro y dispensación de
        bebidas alcohólicas a menores de 18 años.
      </p>

      <p>
        Al formalizar un pedido a través de <strong>aiwannapay</strong> que
        incluya bebidas alcohólicas, el Usuario declara ser mayor de 18 años y
        cumplir con todas las prescripciones legales aplicables a la venta de
        alcohol.
      </p>

      <p>
        El Usuario acepta y reconoce que los profesionales
        <strong>{{ companyShortName }}</strong> no podrán servir el pedido,
        cuando el Usuario no acredite poseer la mayoría de edad, exhibiendo un
        documento oficial a tal efecto; cuando sea de aplicación cualquier
        restricción a la venta de bebidas alcohólicas.
      </p>

      <p>
        <strong>12. Propiedad industrial e intelectual</strong>
      </p>

      <p>
        Todos los contenidos, entendiendo por estos, y sin que esta enumeración
        tenga carácter limitativa, los textos, fotografías, ilustraciones,
        gráficos, software, bases de datos, diseños, gráficos, códigos fuente y
        objeto, contenidos audiovisuales y sonoros, así como los nombres, logos,
        nombres de dominio, marcas y otros signos distintivos que estén
        accesibles en <strong>aiwannapay</strong> (en adelante, los
        “Contenidos”) son objeto de derechos de propiedad industrial e
        intelectual cuya titularidad pertenece a
        <strong>{{ companyShortName }},</strong> o a terceros que han licenciado
        su uso a <strong>{{ companyShortName }}.</strong> Asimismo, los derechos
        sobre la estructura y código informático de
        <strong>aiwannapay</strong> pertenecen a
        <strong>{{ companyShortName }}</strong> como licenciatario. El acceso
        por parte del Usuario a los Contenidos y servicios de
        <strong>aiwannapay</strong> no implica, en ningún caso, ningún tipo de
        renuncia, transmisión o cesión total o parcial de los mencionados
        derechos, ni confiere ningún derecho de utilización, alteración,
        explotación, reproducción, distribución, comunicación pública o
        descompilación sobre los Contenidos objeto de propiedad intelectual o
        industrial. El Usuario disfruta de una licencia no exclusiva de uso de
        <strong>aiwannapay</strong> limitada al acceso a los Contenidos con la
        finalidad de disfrutar de los servicios prestados en la misma. La
        licencia se otorga al Usuario para un uso personal de
        <strong>aiwannapay</strong> y de sus Contenidos, sin poder realizar
        ninguna clase de usos con finalidad comercial o empresarial.
      </p>

      <p>
        <strong>13. Nuestro derecho a modificar estas condiciones</strong>
      </p>

      <p>
        Tenemos derecho a revisar y modificar las presentes Condiciones en
        cualquier momento.
      </p>

      <p>
        Usted estará sujeto a las políticas y Condiciones vigentes en el momento
        en que use
        <strong>aiwannapay</strong> o efectúe cada pedido, salvo que por ley o
        decisión de organismos gubernamentales debamos hacer cambios con
        carácter retroactivo en dichas políticas, Condiciones o Política de
        Privacidad, en cuyo caso, los posibles cambios afectarán también a los
        pedidos que usted hubiera hecho previamente.
      </p>

      <p>
        <strong>14. Protección de Datos De Carácter Personal</strong>
      </p>

      <p>
        En virtud de la normativa de Protección de Datos de Carácter Personal,
        le informamos de que los datos que nos facilite para formalizar la
        transacción serán tratados por
        <strong>{{ companyShortName }}</strong> en su calidad de responsable del
        tratamiento, con la finalidad de gestionar la venta de los productos
        seleccionados, así como, en su caso, remitirte información, incluso por
        medios electrónicos, sobre cuestiones relativas a la actividad de la
        empresa y sus servicios.
      </p>

      <p>
        Sus datos serán tratados con la legitimación que otorgar el cumplimiento
        contractual de la presente relación comercial, y serán almacenados
        durante el tiempo que marca la normativa fiscal.
      </p>

      <p>
        Podrá ejercer, en cualquier momento, los derechos de acceso,
        rectificación, supresión, oposición, limitación de tratamiento y
        potabilidad mediante correo electrónico dirigido a
        <strong>{{ companyEmail }}</strong
        >, adjuntando fotocopia del DNI. Y en el caso de que lo estime oportuno
        podrá presentar una reclamación ante la Agencia Española de Protección
        de Datos.
      </p>

      <p>
        Al hacer uso de esta página web usted consiente el tratamiento de dicha
        información y datos y declara que toda la información o datos que nos
        facilite son veraces y se corresponden con la realidad.
      </p>

      <p>
        <strong>15. Exoneración de responsabilidad</strong>
      </p>

      <p>
        <strong>aiwannapay</strong> puede poner a disposición de los Usuarios
        dispositivos técnicos de enlace (tales como, entre otros, links o
        enlaces, banners, directorios, etc.) que permiten el acceso a páginas
        web o sites pertenecientes y/o gestionados por terceros respecto de las
        cuales <strong>{{ companyShortName }}</strong> no es titular ni tiene
        ningún tipo de vinculación. En consecuencia,
        <strong>{{ companyShortName }}</strong> no será responsable del control
        y vigilancia de los contenidos ni asumirá ninguna responsabilidad sobre
        dichas páginas web o sites. El Usuario deberá extremar la prudencia en
        la valoración y utilización de la información, contenidos y servicios
        puestos a su disposición a través de dichas páginas web o sites
        pertenecientes y/o gestionados por terceros.
      </p>

      <p>
        <strong>{{ companyShortName }}</strong> no puede controlar la
        utilización que el Usuario realice de la <strong>aiwannapay</strong>, y
        de sus servicios y Contenidos, y por ello no será responsable de los
        daños o perjuicios de cualquier naturaleza, incluyendo daños
        informáticos, que pudieran deberse a la ilícita, incorrecta, inapropiada
        o inadecuada utilización que los Usuarios realicen de la
        <strong>aiwannapay</strong>, y de sus servicios o Contenidos.
      </p>

      <p>
        <strong>16. Fuero y legislación aplicable</strong>
      </p>

      <p>
        La venta se entiende efectuada en territorio español, por lo que para
        cuantas cuestiones interpretativas o litigiosas pudieran plantearse,
        será de aplicación la legislación española y, en caso de controversia,
        ambas partes acuerdan someterse, con renuncia a cualquier otro fuero que
        pudiera corresponderle, a la jurisdicción de los Juzgados y Tribunales
        del domicilio del consumidor.
      </p>

      <p>
        Por último, recordamos a los clientes que en el caso de quieran
        presentar una reclamación por alguna incidencia en la relación
        contractual pueden presentar la reclamación oportuna rellenando el
        siguiente formulario electrónico:
        <a href="http://ec.europa.eu/consumers/odr/"
          >http://ec.europa.eu/consumers/odr/</a
        >
      </p>

      <p></p>
    </div>
  </div>
</template>

<script>
import Navbar from "../../../components/public/common/Navbar";
import MiniCart from "../../../components/public/cart/MiniCart";

export default {
  name: "TermsofService",
  components: {
    Navbar,
    MiniCart
  }
};
</script>

<style scoped lang="scss"></style>
